/* eslint-disable import/no-named-as-default */
import React, { useState } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { MONTHLY_GOAL_SURVEY_KEY } from './MonthlyGoalSurvey';
import { useMount } from '../../../hooks';
import StateManager from '../../../modules/user/stateManager';
import useJanitor from '../../../hooks/useJanitor';
import SetAGoalBanner from './SetAGoalBanner';
import AchieveGoalsBanner from './AchieveGoalsBanner';
import { SURVEY_TEXT_RESPONSE } from '../../shared/Surveys/MultipleChoiceSurvey';
import analytics from '../../../modules/analytics';
import withStore from '../../withStore';

type MonthlyGoalBannerProps = {
  /** the provider object */
  provider: { [key: string]: any };
};

const MonthlyGoalBanner = ({ provider }: MonthlyGoalBannerProps) => {
  const [loaded, setLoaded] = useState(false);
  const [goalSet, setGoalSet] = useState(false);
  const janitor = useJanitor();

  const { id: providerId } = provider;

  useMount(() => {
    janitor.addPromise(StateManager.getActionValue(MONTHLY_GOAL_SURVEY_KEY))
      .then(surveySubmitted => {
        if (surveySubmitted && surveySubmitted.time) {
          // we want to set a new goal if it has been 30 days since previous goal was set
          let setNewGoal = moment.utc(surveySubmitted.time).add('days', 30) < moment.utc();

          // The free text input has been deprecated. Force reset of goal if option is selected.
          // If modifying this code more than 30 days since deprecation, this check can be removed.
          if (Object.keys(surveySubmitted.goal)[0] === SURVEY_TEXT_RESPONSE) {
            setNewGoal = true;
          }

          // Reset goal
          if (setNewGoal) {
            StateManager.addAction(MONTHLY_GOAL_SURVEY_KEY, undefined);
            analytics.track('pro_goals_auto_reset_executed');
          }

          if (!setNewGoal) {
            setGoalSet(true);
          }
        }

        setLoaded(true);
      });
  });

  const onSurveySubmitted = () => {
    setGoalSet(true);
  };

  if (!loaded) {
    return null;
  }

  return (
    <Box
      minHeight={44}
      borderWidth={1}
      borderColor={colors.grey3}
      borderStyle="solid"
      borderTopWidth={2}
      borderTopColor={colors.sunshine}
      paddingX={8}
      color={colors.whiteWash}
      style={{ marginTop: 15 }}
    >
      {goalSet && (
        <AchieveGoalsBanner
          providerId={providerId}
        />
      )}
      {!goalSet && (
        <SetAGoalBanner
          onSurveySubmitted={onSurveySubmitted}
          providerId={providerId}
        />
      )}
    </Box>
  );
};

export default withStore(connect()(MonthlyGoalBanner));
